"use strict";

class SpaDatesController {

    constructor($scope,
                $window,
                $timeout,
                SSUserService,
                SSHttpService,
                SSUtilService,
                SSAlertService,
                SSConfigService,
                OTPService,
                SSConfirmationService) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.$timeout = $timeout;
        self.SSUserService = SSUserService;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSConfigService = SSConfigService;
        self.OTPService = OTPService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;

        self.PROPERTY_STATUS_ARCHIVED = SHOWSUITE.PROPERTY_STATUS_ARCHIVED;
        self.SALE_STATUS_PENDING        = SHOWSUITE.SALE_STATUS_PENDING;
        self.SALE_STATUS_VERIFIED       = SHOWSUITE.SALE_STATUS_VERIFIED;
        self.SALE_STATUS_APPROVED       = SHOWSUITE.SALE_STATUS_APPROVED;
        self.SALE_STATUS_REJECTED       = SHOWSUITE.SALE_STATUS_REJECTED;
        self.SALE_STATUS_OTP            = SHOWSUITE.SALE_STATUS_OTP;
        self.SALE_STATUS_CHEQUE_ENTERED = SHOWSUITE.SALE_STATUS_CHEQUE_ENTERED;
        self.SALE_STATUS_SPA_ENTERED    = SHOWSUITE.SALE_STATUS_SPA_ENTERED;
        self.SALE_STATUS_EXERCISED      = SHOWSUITE.SALE_STATUS_EXERCISED;
        self.SALE_STATUS_EXTENDED       = SHOWSUITE.SALE_STATUS_EXTENDED;
        self.SALE_STATUS_EXPIRED        = SHOWSUITE.SALE_STATUS_EXPIRED;
        self.SALE_STATUS_INVALID        = SHOWSUITE.SALE_STATUS_INVALID;
        self.SALE_STATUS_ABORTED        = SHOWSUITE.SALE_STATUS_ABORTED;
        self.SALE_STATUS_DONE           = SHOWSUITE.SALE_STATUS_DONE;

        // Status dropdown — mirrors PaymentApplicationController.sale_statuses
        // so the user sees the same options as on Sales & Payments.
        self.sale_statuses = [
            { id: self.SALE_STATUS_PENDING,     name: 'Pending Buyer Signing' },
            { id: self.SALE_STATUS_VERIFIED,    name: 'Approval Pending' },
            { id: self.SALE_STATUS_APPROVED,    name: 'Approved' },
            { id: self.SALE_STATUS_OTP,         name: 'Pending SPA' },
            { id: self.SALE_STATUS_SPA_ENTERED, name: 'SPA Entered' },
            { id: self.SALE_STATUS_EXERCISED,   name: 'Exercised' },
            { id: self.SALE_STATUS_REJECTED,    name: 'Rejected' },
            { id: self.SALE_STATUS_ABORTED,     name: 'Aborted' },
            { id: self.SALE_STATUS_DONE,        name: 'Completed' }
        ];

        // Default status filter when "All Status" is picked or no status is
        // selected. Matches PaymentApplicationController.retrieveApplications's
        // default exactly so this page sees the same baseline rows as the
        // Sales & Payments page (verified to return all sales for a project).
        // The API requires `status` to be set — omitting it returns 0 rows.
        self.DEFAULT_STATUSES = [
            self.SALE_STATUS_VERIFIED,
            self.SALE_STATUS_REJECTED,
            self.SALE_STATUS_APPROVED,
            self.SALE_STATUS_OTP,
            self.SALE_STATUS_CHEQUE_ENTERED,
            self.SALE_STATUS_SPA_ENTERED,
            self.SALE_STATUS_EXTENDED,
            self.SALE_STATUS_EXERCISED,
            self.SALE_STATUS_EXPIRED,
            self.SALE_STATUS_INVALID,
            self.SALE_STATUS_ABORTED,
            self.SALE_STATUS_DONE
        ].filter(function (s) { return s != null; });

        // Maximum items per bulk request. Conservative chunk size pending
        // backend confirmation of the per-request cap (WEB-3414).
        self.BULK_CHUNK_SIZE = 500;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.properties = [];
        self.sales = [];
        self.property_id = '';
        self.sale_status = '';
        self.search_by = 'unit_no';
        self.search_value = '';
        self.limit = 50;
        self.current = 1;
        self.offset = 0;
        self.total_count = 0;

        // Sort state — sort_by maps to a sale-table column; the order_by
        // JSON string sent to the API is rebuilt from these two each time
        // the user clicks a header (see setSort).
        self.sort_by = 'otp_date';
        self.sort_dir = 'desc';
        self.order_by = '{"otp_date": "desc"}';

        self.checkboxes = { checked: false, items: {} };
        self.selectAllMatching = false;
        self.bulk = { type: null, date: null, results: null };

        self.prepareDeveloperProperties();
        self.getStatusConfig();
        self.initDatepicker();

        // The status dropdown's <option>s are emitted by Angular via
        // ng-options after the controller constructor runs, but niceSelect()
        // in the inline blade script captures the DOM before that and would
        // otherwise show only the placeholder. Re-init niceSelect on a
        // $timeout so it picks up the now-populated <option>s.
        self.$timeout(function () {
            $('.dashboard-select').niceSelect('update');
        });
    }

    initDatepicker() {
        const self = this;

        // The shared datepicker uses jQuery UI. Re-bind whenever the modal
        // re-attaches its input.
        self.$timeout(function () {
            $('.datepicker').datepicker({
                changeMonth: true,
                changeYear: true,
                dateFormat: 'dd/mm/yy',
                onSelect: function (dateText) {
                    self.$scope.$apply(function () {
                        self.bulk.date = dateText;
                    });
                }
            });
        });
    }

    prepareDeveloperProperties() {
        const self = this;

        let url = 'sec/developer/properties/list';
        let params = {
            include: 'unit_statuses',
            status: '30,50' // Approved, Listed
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.properties) {
                $.each(response.data.properties, function (i, property) {
                    if (property.status != self.PROPERTY_STATUS_ARCHIVED) {
                        self.properties.push(property);
                    }
                });
            }

            self.properties = self.properties.sort(function (a, b) {
                return b.id - a.id;
            });

            if (self.properties.length) {
                let savedPropertyId = self.SSUtilService.getFromLocalStorage('lastPropertyId');
                if (savedPropertyId && self.properties.some(function (p) { return p.id == savedPropertyId; })) {
                    self.property_id = parseInt(savedPropertyId);
                } else {
                    self.property_id = parseInt(self.properties[0].id);
                    self.SSUtilService.saveToLocalStorage('lastPropertyId', self.property_id);
                }
            }

            self.$timeout(function () {
                $('select.dashboard-select#property-select').niceSelect('update');
            });

            if (self.property_id) {
                self.retrieveSales(1);
            }
        });
    }

    getStatusConfig() {
        const self = this;

        self.SSHttpService.getAPIRequest('config').then(function (response) {
            if (response instanceof Error) {
                return;
            }
            self.saleStatus = response.data.sale_statuses;
        });
    }

    checkStatus(sale) {
        const self = this;

        if (!sale || !sale.status || !self.saleStatus) {
            return null;
        }

        let display = null;
        $.each(self.saleStatus, function (i, status) {
            if (status.id === sale.status) {
                display = status.display;
                return false;
            }
        });
        return display;
    }

    onPropertyChange() {
        const self = this;

        // Property changed — selection is no longer valid (bulk endpoints are
        // single-property, so we must not carry IDs across projects).
        self.clearSelection();
        self.SSUtilService.saveToLocalStorage('lastPropertyId', self.property_id);
        self.updateFilter();
    }

    updateFilter() {
        const self = this;

        self.offset = 0;
        self.current = 1;
        self.retrieveSales(1);
    }

    pageChanged(newPage) {
        const self = this;

        self.retrieveSales(newPage);
    }

    // Toggle sorting for the given sale column. Clicking the active column
    // flips asc <-> desc; clicking a different column resets to desc and
    // reloads the listing from page 1.
    setSort(column) {
        const self = this;

        if (!column) return;

        if (self.sort_by === column) {
            self.sort_dir = (self.sort_dir === 'asc') ? 'desc' : 'asc';
        } else {
            self.sort_by = column;
            self.sort_dir = 'desc';
        }
        self.order_by = '{"' + self.sort_by + '": "' + self.sort_dir + '"}';
        self.retrieveSales(1);
    }

    // Indicator string appended to the header label of the active sort
    // column. Returns '' for non-active columns so the UI stays compact.
    getSortIcon(column) {
        const self = this;

        if (self.sort_by !== column) return '';
        return self.sort_dir === 'asc' ? ' ▲' : ' ▼';
    }

    retrieveSales(page, show_loading = true) {
        const self = this;

        if (!self.property_id) {
            self.sales = [];
            self.total_count = 0;
            return;
        }

        let offset = (page * self.limit) - self.limit;
        self.current = page;
        self.offset = offset;

        // The API requires `status` — omitting it returns 0 rows even
        // though the property has sales (verified against Sales & Payments).
        // When no specific status is picked, send the same 12-status list
        // PaymentApplicationController uses by default.
        let statusParam = self.sale_status
            ? String(self.sale_status)
            : self.DEFAULT_STATUSES.join(',');

        let params = {
            property_id: self.property_id,
            status: statusParam,
            limit: self.limit,
            offset: offset,
            include: 'units',
            send_total_count: true,
            order: self.order_by
        };

        if (self.search_value) {
            params[self.search_by] = self.search_value;
        }

        if (show_loading) loading(true);
        self.SSHttpService.getAPIRequest('sec/developer/sales', params).then(function (response) {
            if (show_loading) loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.sales = response.data.sales || [];
            self.total_count = response.data.total_count || 0;

            // The API returns `units` as a flat top-level array on the
            // response, not nested per-sale. Mirror the join pattern from
            // PaymentApplicationController.retrieveApplications (payment.js:1374)
            // so the UNIT column has something to render.
            let units = (response.data && response.data.units) ? response.data.units : [];
            $.each(self.sales, function (i, sale) {
                if (sale.unit_id) {
                    sale.unit = units.find(function (u) { return u.id === sale.unit_id; });
                }
            });

            self.syncHeaderCheckbox();
        });
    }

    // -------------------- Selection --------------------

    toggleRow(sale) {
        const self = this;

        if (!self.checkboxes.items[sale.id]) {
            delete self.checkboxes.items[sale.id];
        }

        // If the user manually unchecks a row while in "select all matching"
        // mode, downgrade to per-row selection.
        if (self.selectAllMatching && !self.checkboxes.items[sale.id]) {
            self.selectAllMatching = false;
        }

        self.syncHeaderCheckbox();
    }

    togglePage() {
        const self = this;

        let checked = self.checkboxes.checked;
        $.each(self.sales, function (i, sale) {
            if (checked) {
                self.checkboxes.items[sale.id] = true;
            } else {
                delete self.checkboxes.items[sale.id];
            }
        });

        if (!checked) {
            self.selectAllMatching = false;
        }
    }

    syncHeaderCheckbox() {
        const self = this;

        if (!self.sales || !self.sales.length) {
            self.checkboxes.checked = false;
            return;
        }
        let allChecked = self.sales.every(function (sale) {
            return !!self.checkboxes.items[sale.id];
        });
        self.checkboxes.checked = allChecked;
    }

    selectAllMatchingFilter() {
        const self = this;

        if (!self.property_id) return;

        let statusParam = self.sale_status
            ? String(self.sale_status)
            : self.DEFAULT_STATUSES.join(',');

        let params = {
            property_id: self.property_id,
            status: statusParam,
            limit: 10000,
            offset: 0,
            fields: 'id'
        };
        if (self.search_value) {
            params[self.search_by] = self.search_value;
        }

        loading(true);
        self.SSHttpService.getAPIRequest('sec/developer/sales', params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            let sales = response.data.sales || [];
            $.each(sales, function (i, sale) {
                self.checkboxes.items[sale.id] = true;
            });
            self.selectAllMatching = true;
            self.syncHeaderCheckbox();
        });
    }

    clearSelection() {
        const self = this;

        self.checkboxes.items = {};
        self.checkboxes.checked = false;
        self.selectAllMatching = false;
    }

    getSelectedIds() {
        const self = this;

        let ids = [];
        for (let key in self.checkboxes.items) {
            if (self.checkboxes.items[key]) {
                ids.push(parseInt(key));
            }
        }
        return ids;
    }

    getSelectedCount() {
        return this.getSelectedIds().length;
    }

    getSelectedPropertyName() {
        const self = this;

        let property = self.properties.find(function (p) { return p.id == self.property_id; });
        return property ? property.name : '';
    }

    // -------------------- Bulk Update --------------------

    // Force-reset the two bulk-SPA modals' state and clear any stray
    // Bootstrap modal-backdrop / body class. Use before any .modal('show')
    // call to avoid Bootstrap 4-alpha's "Modal is transitioning" error,
    // which fires when a prior close was interrupted (e.g. user X'd the
    // outer modal while the OTP modal was stacked on top, leaving
    // _isTransitioning=true on the cached modal instance). removeData
    // clears the cached instance so the next show creates a fresh one.
    resetBulkModalState() {
        $('#modal_bulk_spa_date').removeData('bs.modal');
        $('#modal_bulk_spa_results').removeData('bs.modal');
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');
    }

    getBulkTypeLabel() {
        const self = this;

        switch (self.bulk.type) {
            case 'delivery': return 'SPA Delivery Date';
            case 'receipt':  return 'SPA Receipt Date';
            case 'exercise': return 'SPA Exercise Date';
            default:         return 'SPA Date';
        }
    }

    openBulkUpdate(type) {
        const self = this;

        if (!self.property_id) {
            self.SSAlertService.danger('Project required', 'Select a project before bulk updating SPA dates.');
            return;
        }
        if (self.getSelectedCount() === 0) {
            self.SSAlertService.danger('No sales selected', 'Select at least one sale to bulk update.');
            return;
        }

        self.bulk.type = type;
        self.bulk.date = null;
        self.bulk.results = null;

        // Two transition races to handle:
        // 1. openBulkUpdate fires from a Bootstrap dropdown click; the
        //    dropdown's hide-transition collides with the modal's show.
        // 2. A prior cycle may have left a stale modal-backdrop or a
        //    cached modal instance with _isTransitioning=true (typically
        //    after the user closed this modal via X while the OTP modal
        //    was stacked on top). Reset state, then defer the show.
        self.resetBulkModalState();
        self.$timeout(function () {
            $('#modal_bulk_spa_date').modal('show');

            self.$timeout(function () {
                $('.bulk-spa-datepicker').datepicker({
                    changeMonth: true,
                    changeYear: true,
                    dateFormat: 'dd/mm/yy',
                    onSelect: function (dateText) {
                        self.$scope.$apply(function () {
                            self.bulk.date = dateText;
                        });
                    }
                });
            }, 200);
        }, 250);
    }

    cancelBulkUpdate() {
        const self = this;

        self.bulk.type = null;
        self.bulk.date = null;
    }

    applyBulkUpdate() {
        const self = this;

        let ids = self.getSelectedIds();
        if (!ids.length || !self.bulk.date || !self.bulk.type) return;

        let dateYmd = self.convertDateToYmd(self.bulk.date);
        if (!dateYmd) {
            self.SSAlertService.danger('Invalid date', 'Please enter a valid date in DD/MM/YYYY format.');
            return;
        }

        let url;
        switch (self.bulk.type) {
            case 'delivery': url = 'sec/developer/sales/bulk-enter-spa-delivery'; break;
            case 'receipt':  url = 'sec/developer/sales/bulk-enter-spa'; break;
            case 'exercise': url = 'sec/developer/sales/bulk-exercise'; break;
            default: return;
        }

        // Hide our modal BEFORE triggering the 2FA flow. OTPService opens
        // its own Bootstrap modal; if ours is still open, the OTP modal
        // stacks behind us and the user can't see the input. Hide first,
        // wait for the transition to finish, then start OTP.
        $('#modal_bulk_spa_date').modal('hide');
        self.$timeout(function () {
            self.OTPService.getVerified(
                self.OTPService.TYPE_SESSION_2FA,
                function () {
                    self.runBulkUpdate(url, ids, dateYmd);
                }
            );
        }, 350);
    }

    runBulkUpdate(url, ids, dateYmd) {
        const self = this;

        // WEB-3414 bulk endpoint contract:
        //   request:  { property_id, items: [{sale_id, date}, ...] }
        //   response: { processed, succeeded, failed, errors: [{sale_id, code, message}] }
        // Build the per-row items list, then chunk by BULK_CHUNK_SIZE.
        let items = ids.map(function (id) {
            return { sale_id: id, date: dateYmd };
        });

        let chunks = [];
        for (let i = 0; i < items.length; i += self.BULK_CHUNK_SIZE) {
            chunks.push(items.slice(i, i + self.BULK_CHUNK_SIZE));
        }

        let aggregated = {
            total: items.length,
            success_count: 0,
            error_count: 0,
            errors: []
        };

        // Build a quick lookup so error rows can show unit numbers.
        let saleById = {};
        $.each(self.sales || [], function (i, sale) { saleById[sale.id] = sale; });

        loading(true);
        let chain = Promise.resolve();
        chunks.forEach(function (chunk) {
            chain = chain.then(function () {
                return self.SSHttpService.putAPIRequest(url, {
                    property_id: self.property_id,
                    items: chunk
                }).then(function (response) {
                    if (response instanceof Error) {
                        // Whole chunk failed — record one synthetic error per id.
                        aggregated.error_count += chunk.length;
                        chunk.forEach(function (item) {
                            let sale = saleById[item.sale_id];
                            aggregated.errors.push({
                                sale_id: item.sale_id,
                                unit_no: sale && sale.unit ? self.SSUtilService.getFullUnitNumber1(sale.unit) : null,
                                message: (response && response.message) ? response.message : 'Request failed'
                            });
                        });
                        return;
                    }

                    let data = response.data || {};
                    let errors = (data.errors || []).map(function (e) {
                        let sale = saleById[e.sale_id];
                        return {
                            sale_id: e.sale_id,
                            unit_no: sale && sale.unit ? self.SSUtilService.getFullUnitNumber1(sale.unit) : null,
                            code: e.code,
                            message: e.message
                        };
                    });
                    aggregated.errors = aggregated.errors.concat(errors);
                    // Prefer server-provided counters when present; fall back
                    // to deriving from chunk size minus errors.
                    let succeeded = (data.succeeded != null)
                        ? data.succeeded
                        : (chunk.length - errors.length);
                    let failed = (data.failed != null) ? data.failed : errors.length;
                    aggregated.success_count += succeeded;
                    aggregated.error_count += failed;
                });
            });
        });

        chain.then(function () {
            loading(false);
            self.bulk.results = aggregated;

            // Belt-and-braces: applyBulkUpdate already hid the date modal
            // before triggering 2FA, but reset state so the results modal
            // shows cleanly even if the OTP flow left a stale backdrop.
            self.resetBulkModalState();
            self.$timeout(function () {
                $('#modal_bulk_spa_results').modal('show');
            }, 350);
        }, function (err) {
            loading(false);
            self.SSAlertService.parseAndDisplayError(err);
        });
    }

    closeBulkResults() {
        const self = this;

        $('#modal_bulk_spa_results').modal('hide');
        self.bulk.type = null;
        self.bulk.date = null;
        self.bulk.results = null;
        self.clearSelection();
        self.retrieveSales(self.current, false);
    }

    convertDateToYmd(dateStr) {
        if (!dateStr) return null;
        let m = moment(dateStr, ['DD/MM/YYYY', 'YYYY-MM-DD'], true);
        return m.isValid() ? m.format('YYYY-MM-DD') : null;
    }

    // -------------------- Export --------------------

    exportSpaDates() {
        const self = this;

        if (!self.property_id) {
            self.SSAlertService.danger('Project required', 'Select a project to export SPA dates.');
            return;
        }

        let params = { property_id: self.property_id };
        if (self.sale_status) params.status = self.sale_status;
        if (self.search_value) params[self.search_by] = self.search_value;

        let url = self.SSHttpService.getApiURL('sec/developer/sales/export-spa-dates');
        url += (url.indexOf('?') === -1 ? '?' : '&');
        url += $.param(params);

        self.$window.location.href = url;
    }
}

SpaDatesController.$inject = [
    '$scope',
    '$window',
    '$timeout',
    'SSUserService',
    'SSHttpService',
    'SSUtilService',
    'SSAlertService',
    'SSConfigService',
    'OTPService',
    'SSConfirmationService'
];
app.controller('SpaDatesController', SpaDatesController);
